import React from 'react';
import numeral from 'numeral';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../../state/fetch-dux';

const ItemsSummary = ({ items, putCartItem, review, deleteCartItem }) => {
  return (
    <table width="100%" className="items">
      <thead>
        <tr>
          <th>Item</th>
          <th className="text-right">Qty</th>
          <th className="text-right">Unit Price</th>
        </tr>
      </thead>
      <tbody>
        {(items || []).map((item, index) => {
          const {
            shoppingCartItemId,
            skuDescription,
            unitPrice,
            discount
          } = item || {};
          const handleQtyChange = e => {
            const { value } = e.target || {};
            putCartItem({
              id: shoppingCartItemId,
              payload: { qty: parseInt(value) }
            });
          };
          const onRemoveItem = e => {
            e.preventDefault();
            deleteCartItem(shoppingCartItemId);
          };
          return (
            <tr key={index}>
              <td>{skuDescription}</td>
              <td>
                {review
                  ? `${item.qty}`
                  : <select value={item.qty} onChange={handleQtyChange}>
                      {Array.from(
                        // TODO
                        Array(item.qty > 99 ? item.qty : 99)
                      ).map((quantity, index) => (
                        <option value={index + 1} key={index}>
                          {index + 1}
                        </option>
                      ))}
                    </select>}
              </td>
              <td className="text-right">
                <div>{numeral(unitPrice).format('$0,0.00')} USD</div>
                {!!discount &&
                  <div style={{ color: '#900' }}>
                    -{numeral(discount).format('$0,0.00')} USD
                  </div>}
                {!review &&
                  <a href="#" className="remove" onClick={onRemoveItem}>
                    {' '}× Remove
                  </a>}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const mapState = state => {
  return {};
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      putCartItem: fetchDux.putCartItem.createAction,
      deleteCartItem: fetchDux.deleteCartItem.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(ItemsSummary);
